export default __webpack_public_path__ + "static/media/illustration-hero.07801d05.svg";